<template lang="pug">
validation-provider(
  :rules="`${required ? 'required|' + 'min:' + minSymbols + '|': ''}max:${maxSymbols}`"
  :name="name"
  v-slot="{ errors }"
)
  v-textarea.validation-textarea.body-2.font-weight-light.relative(
    v-model="inputValue"
    ref="textArea"
    auto-grow
    solo
    flat
    :rows="rows"
    full-width
    :placeholder="placeholder"
    :error="!!errors.length"
    hide-details
    v-bind="$attrs"
    :outlined="isOutlined && !errors.length"
    @height="heightResize"
  )
    template(#append)
      .d-flex.justify-space-between.flex-wrap(
        :class="{ 'align-center gap-8': soloLineInput, 'flex-column align-end': !soloLineInput }"
      )
        v-btn(
          :class="{ 'opacity-0 pointer-events-none' : !inputValue.length }"
          icon
          small
          color="redesignSecondary"
          @click="clearInput"
        )
          v-icon(size="20") mdi-close
        .redesignDisabledText--text
          span(
            :class=`{
              'redesignError--text': !!errors.length && (((inputValue.length < minSymbols) && required) || inputValue.length > maxSymbols)
            }`
          ) {{ inputValue.length }}
          | /{{ maxSymbols }}

</template>

<script>
export default {
  name: 'ValidationTextArea',

  props: {
    value: { type: [String, Number], default: '' },
    placeholder: { type: String, default: '' },
    rows: { type: [String, Number], default: 1 },
    maxSymbols: { type: [String, Number], default: 600 },
    minSymbols: { type: [String, Number], default: 5 },
    name: { type: String, default: 'Введите текст' },
    required: { type: Boolean, default: true },
  },

  data() {
    return {
      resizeObserver: null,
      soloLineInput: this.rows === 1,
    };
  },

  computed: {
    inputValue: {
      get() {
        return this.value || '';
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isOutlined() {
      return Object.prototype.hasOwnProperty.call(this.$attrs, 'outlined') && this.$attrs.outlined !== false;
    },
  },

  mounted() {
    this.resizeObserver = new ResizeObserver(this.heightResize);
    this.resizeObserver.observe(this.textAreaInput());
  },

  beforeDestroy() {
    this.resizeObserver.unobserve(this.textAreaInput());
  },

  methods: {
    clearInput() {
      this.inputValue = '';
    },
    textAreaInput() {
      if (!this.$refs.textArea) return null;
      return this.$refs.textArea.$refs.input;
    },
    heightResize(obsEntries) {
      const [obsEntry] = obsEntries;
      if (obsEntry?.target) {
        const { height } = obsEntry.target.getBoundingClientRect();
        this.soloLineInput = height < 50;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-textarea {
  &:not(.error--text)::v-deep .v-input__slot {
    border-color: transparent !important;
  }

  &::v-deep .v-input__control {
    min-height: 40px;
  }

  &::v-deep .v-input__slot {
    align-items: stretch;
    padding: 4px 8px !important;
    margin-bottom: 0px !important;
    border: 1px solid currentColor;
    min-height: 30px !important;
  }
  &::v-deep textarea {
    margin: 0 !important;
  }
  &::v-deep .v-input__append-inner {
    align-self: stretch;
    margin: 0 !important;
  }
}
</style>
